<template>
  <vs-table hover-flat v-if="tasks && tasks.length" :data="tasks">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('name')"></vs-th>
      <vs-th v-text="$t('category')"></vs-th>
      <vs-th v-text="$t('due_date')"></vs-th>
      <vs-th v-text="$t('assigned_users')"></vs-th>
      <vs-th class="text-center" v-text="$t('progress')"></vs-th>
      <vs-th class="text-center" v-text="$t('priority')"></vs-th>
      <vs-th class="text-center" v-text="$t('status')"></vs-th>
      <vs-th class="text-center" v-text="$t('action')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="tr.name" :data-tr-title="$t('name')"></vs-td>
        <vs-td v-text="tr.category_name" :data-tr-title="$t('category')"></vs-td>
        <vs-td v-text="tr.due_date" :data-tr-title="$t('due_date')"></vs-td>
        <vs-td :data-tr-title="$t('assigned_users')">
          <ul v-if="tr.users.length > 0">
            <li v-for="(user, index) in tr.users" :key="index" v-text="user.name"></li>
          </ul>
          <span v-else>--</span>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" v-text="`${tr.progress}%`" :data-tr-title="$t('progress')"></vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('priority')">
          <badge-priority :content="tr.priority.name" :status="tr.priority.id"></badge-priority>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('status')">
          <badge-status :content="tr.status.name" :status="tr.status.id"></badge-status>
        </vs-td>
        <vs-td class="text-center">
          <div class="flex justify-center">
            <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="$emit('customClickEdit', tr.id)"></vs-button>&nbsp;
            <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="$emit('customClickDelete', tr.id)"></vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
import BadgePriority from '@/components/badge/Priority'
import BadgeStatus from '@/components/badge/Status'

export default {
  name: 'Shared.Tasks.List',
  components: {
    BadgePriority,
    BadgeStatus
  },
  props: {
    tasks: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
